module.exports = __webpack_public_path__ + "img/sword-fire-01.4ca527d4.png";